import { UnknownAction } from 'redux'
import { SET_IS_PREVIEW_MODE } from 'src/editor/store/website-pages/website-pages-action-types'
import { WebsitePagesActions } from 'src/editor/store/website-pages/website-pages-actions'

export interface WebsitePagesState {
  isPreviewMode: boolean
}

const WEBSITE_PAGES_DEFAULT_STATE: WebsitePagesState = {
  isPreviewMode: false,
}

export interface SetIsPreviewMode {
  type: typeof SET_IS_PREVIEW_MODE
  payload: boolean
}

export const websitePagesReducer = (
  state: WebsitePagesState = WEBSITE_PAGES_DEFAULT_STATE,
  action: WebsitePagesActions | UnknownAction,
) => {
  switch (action.type) {
    case SET_IS_PREVIEW_MODE:
      return {
        ...state,
        isPreviewMode: action.payload,
      }
    default:
      return state
  }
}
